<template>
    <div>
      <el-form label-width="170px" class="xzformitemmb">
        <el-row>
          <panel title="应收质押信息" border>
            <el-col :span="12">
              <el-form-item label="质押批次号：">
                {{data.pl__pledgeNo}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质押状态：">
                {{data.pl__pledgeStatus|Status2CN}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称：">
                {{contractData.ct__customerName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应链：">
                {{contractData.ct__debtorName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="额度核定书金额：">
                {{contractData.ct__lineOfCredit}} 元
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="可用额度：">
                {{contractData.ct__lineOfCredit}} 元
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同起始日：">
                {{contractData.ct__contractValidity1|moment('YYYY-MM-DD')}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同到期日：">
                {{contractData.ct__contractValidity2|moment('YYYY-MM-DD')}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务费：">
                {{contractData.ct__lendingFee}} {{contractData.ct__lendingFeeType=='Rate' ? '%' : '元'}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="融资利率：">
                {{contractData.ct__interestRate}} % ({{contractData.ct__interestType|Status2CN}})
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务费收取方式：">
                {{contractData.ct__lendingFeeType|Status2CN}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="利息收取节点：">
                {{contractData.ct__interestPayTime}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="费用收取节点：">
                {{contractData.ct__lendingFeePayTime}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="融资比例：">
                {{contractData.ct__financingRatio}} %
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="通知方式：">
                {{data.pl__channel}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质押日期：">
                {{data.pl__pledgeDate|moment('YYYY-MM-DD')}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="本次转让发票总额：">
                {{data.pl__pledgeAmount}} 元
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="本次转让发票数量：">
                {{data.invoices.length}}
              </el-form-item>
            </el-col>

          </panel>
        </el-row>
      </el-form>
      <panel title="应收账款列表" border>
        <invoices-data-table :invoices="data.invoices" :columns="invoiceColumns"/>
      </panel>
      <panel title="附件列表">
        <files-data-table :files="data.files" />
      </panel>
    </div>
</template>

<script>
  import Panel from '../../components/Panel'
  import FilesDataTable from '../../components/FilesDataTable'
  import InvoicesDataTable from './InvoicesDataTable'
  import FormBuild from '../../components/FormBuild'
  import Status2CN from "../../filters/Status2CN";

  export default {
    name: "PledgeDetailComponent",
    data() {
      return {
        invoiceColumns: [
          {
            name: '单据类型',
            field: 'pi__invoiceType'
          },
          {
            name: '单据号码',
            field: 'pi__invoiceNo'
          },
          {
            name: '单据金额',
            field: 'pi__totalAmount',
          },
          {
            name: '质押金额',
            field: 'pi__pledgeAmount'
          },
          {
            name: '币种',
            field: 'pi__currencyCode',
            formatter: function(r,c,v) {
              return '人民币'
            }
          },
          {
            name: '单据日期',
            field: 'pi__invoiceDate',
          },
          {
            name: '到期日',
            field: 'pi__dueDate',
          }
        ],
        formColumnsGroup: [
          {
            label: '应收质押信息',
            columns: [
              {
                label: '质押批次号',
                field: 'pl__pledgeNo'
              },
              {
                label: '质押状态',
                field: 'pl__pledgeStatus',
                filter: 'Status2CN',
                formatter: function (v) {
                  return Status2CN(v)
                }
              },
              {
                label: '企业名称',
                field: 'pl__pledgeNo'
              },
              {
                label: '供应链',
                field: 'pl__pledgeNo'
              },
              {
                label: '额度核定书金额',
                field: 'pl__pledgeNo'
              },
              {
                label: '可用额度',
                field: 'pl__pledgeNo'
              },
              {
                label: '合同起始日',
                field: 'pl__pledgeNo'
              },
              {
                label: '合同到期日',
                field: 'pl__pledgeNo'
              },
              {
                label: '融资费率（%）',
                field: 'pl__pledgeNo'
              },
              {
                label: '融资月利率（%）',
                field: 'pl__pledgeNo'
              },
              {
                label: '管理费收费类型',
                field: 'pl__pledgeNo'
              },
              {
                label: '利息收取节点',
                field: 'pl__pledgeNo'
              },
              {
                label: '费用收取节点',
                field: 'pl__pledgeNo'
              },
              {
                label: '融资比例(%) ',
                field: 'pl__pledgeNo'
              },
              {
                label: '通知方式',
                field: 'pl__pledgeNo'
              },
              {
                label: '质押日期',
                field: 'pl__pledgeNo'
              },
              {
                label: '本次转让发票总额',
                field: 'pl__pledgeNo'
              },
              {
                label: '本次转让发票数量',
                field: 'pl__pledgeNo'
              },
            ]
          }
        ]
      }
    },
    props: {
      data: {
        type: Object,
        default:()=>{
          return {
            invoices: []
          }
        }
      },
      contractData: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    components: {
      Panel,
      FilesDataTable,
      InvoicesDataTable,
      FormBuild
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/PledgeDetailComponent.vue